module.exports = __webpack_public_path__ + "static/media/Niveau_elN7_2_718293.f049dfe7.png";